<div class="app-layout">
  <div
    class="app-layout__side-panel"
    [ngClass]="{ 'app-layout__side-panel--default': !expanded, 'app-layout__side-panel--expanded': expanded }"
  >
    <ftr-side-nav-display
      [navGroups]="navGroups().navGroups"
      [expanded]="expanded"
      (toggleExpanded)="handleSidebarToggle()"
    ></ftr-side-nav-display>
  </div>
  <div class="app-layout__main-panel">
    <ftr-top-bar-display [sideBarOpened]="opened" (sideBarToggled)="handleSidebarOpen()"></ftr-top-bar-display>
    <div class="app-layout__content-wrapper">
      <div
        class="app-layout__slide"
        [ngClass]="{ 'app-layout__slide--close': !opened, 'app-layout__slide--open': opened }"
      >
        <div class="app-layout__side-panel-mobile">
          <ftr-side-nav-display
            [navGroups]="navGroups().navGroups"
            [expanded]="true"
            (toggleExpanded)="handleSidebarOpen(false)"
            displayMode="OVERLAY"
          ></ftr-side-nav-display>
        </div>
        <div class="app-layout__slide-backdrop" (click)="handleSidebarOpen(false)"></div>
      </div>
      <div
        class="app-layout__content"
        [ngClass]="{
          'app-layout__content--grey-background': !routeDataSignal()?.whiteBackground
        }"
      >
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
